// Datasets de comparativa: período / centro / especialidad

export const comparativaPorCentro = {
  opciones: [
    "CMSJ San Joaquín",
    "Hospital Clínico UC",
    "CM Lira",
    "CM Escuela Militar",
    "Clínica San Carlos de Apoquindo",
    "CM Santa Lucía",
    "CM Marcoleta",
  ],
  // matriz etapa × centro
  datos: {
    "CMSJ San Joaquín": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 62300 },
        { etapa: "Agendamiento", valor: 41800 },
        { etapa: "Consulta", valor: 38200 },
        { etapa: "Indicación", valor: 18600 },
        { etapa: "Lab Realizado", valor: 19400 },
        { etapa: "Imagen Realizada", valor: 14800 },
        { etapa: "Control", valor: 6200 },
      ],
      fuga_global: 54.8,
      tiempo_espera_min: 18,
      nps: 74,
      volumen_total: 62300,
    },
    "Hospital Clínico UC": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 48200 },
        { etapa: "Agendamiento", valor: 31400 },
        { etapa: "Consulta", valor: 29100 },
        { etapa: "Indicación", valor: 14500 },
        { etapa: "Lab Realizado", valor: 13600 },
        { etapa: "Imagen Realizada", valor: 10200 },
        { etapa: "Control", valor: 4100 },
      ],
      fuga_global: 58.2,
      tiempo_espera_min: 25,
      nps: 68,
      volumen_total: 48200,
    },
    "CM Lira": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 35400 },
        { etapa: "Agendamiento", valor: 22800 },
        { etapa: "Consulta", valor: 20900 },
        { etapa: "Indicación", valor: 9900 },
        { etapa: "Lab Realizado", valor: 10200 },
        { etapa: "Imagen Realizada", valor: 7500 },
        { etapa: "Control", valor: 3200 },
      ],
      fuga_global: 56.5,
      tiempo_espera_min: 20,
      nps: 71,
      volumen_total: 35400,
    },
    "CM Escuela Militar": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 28900 },
        { etapa: "Agendamiento", valor: 19200 },
        { etapa: "Consulta", valor: 17800 },
        { etapa: "Indicación", valor: 9100 },
        { etapa: "Lab Realizado", valor: 9800 },
        { etapa: "Imagen Realizada", valor: 6900 },
        { etapa: "Control", valor: 3500 },
      ],
      fuga_global: 53.1,
      tiempo_espera_min: 16,
      nps: 78,
      volumen_total: 28900,
    },
    "Clínica San Carlos de Apoquindo": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 24100 },
        { etapa: "Agendamiento", valor: 15200 },
        { etapa: "Consulta", valor: 13800 },
        { etapa: "Indicación", valor: 6700 },
        { etapa: "Lab Realizado", valor: 6100 },
        { etapa: "Imagen Realizada", valor: 4500 },
        { etapa: "Control", valor: 1900 },
      ],
      fuga_global: 59.4,
      tiempo_espera_min: 22,
      nps: 66,
      volumen_total: 24100,
    },
    "CM Santa Lucía": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 21800 },
        { etapa: "Agendamiento", valor: 14300 },
        { etapa: "Consulta", valor: 13100 },
        { etapa: "Indicación", valor: 6400 },
        { etapa: "Lab Realizado", valor: 6200 },
        { etapa: "Imagen Realizada", valor: 4700 },
        { etapa: "Control", valor: 2100 },
      ],
      fuga_global: 55.9,
      tiempo_espera_min: 19,
      nps: 73,
      volumen_total: 21800,
    },
    "CM Marcoleta": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 18700 },
        { etapa: "Agendamiento", valor: 12100 },
        { etapa: "Consulta", valor: 11200 },
        { etapa: "Indicación", valor: 5600 },
        { etapa: "Lab Realizado", valor: 5400 },
        { etapa: "Imagen Realizada", valor: 3900 },
        { etapa: "Control", valor: 1800 },
      ],
      fuga_global: 54.2,
      tiempo_espera_min: 17,
      nps: 75,
      volumen_total: 18700,
    },
  },
};

export const comparativaPorEspecialidad = {
  opciones: [
    "Medicina Familiar",
    "Cardiología",
    "Oftalmología",
    "Pediatría",
    "Endocrinología",
    "Traumatología",
    "Dermatología",
    "Ginecología y Obstetricia",
    "Neurología",
    "Psiquiatría",
    "Otorrinolaringología",
    "Medicina General",
  ],
  datos: {
    "Medicina Familiar": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 52400 },
        { etapa: "Agendamiento", valor: 34100 },
        { etapa: "Consulta", valor: 31800 },
        { etapa: "Indicación", valor: 19200 },
        { etapa: "Lab Realizado", valor: 18500 },
        { etapa: "Imagen Realizada", valor: 9200 },
        { etapa: "Control", valor: 7800 },
      ],
      fuga_global: 61.2,
      tiempo_espera_min: 22,
      nps: 72,
      volumen_total: 52400,
    },
    "Cardiología": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 34200 },
        { etapa: "Agendamiento", valor: 22800 },
        { etapa: "Consulta", valor: 20900 },
        { etapa: "Indicación", valor: 15100 },
        { etapa: "Lab Realizado", valor: 13200 },
        { etapa: "Imagen Realizada", valor: 11800 },
        { etapa: "Control", valor: 6500 },
      ],
      fuga_global: 58.5,
      tiempo_espera_min: 28,
      nps: 76,
      volumen_total: 34200,
    },
    "Oftalmología": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 28600 },
        { etapa: "Agendamiento", valor: 19200 },
        { etapa: "Consulta", valor: 17800 },
        { etapa: "Indicación", valor: 8900 },
        { etapa: "Lab Realizado", valor: 2100 },
        { etapa: "Imagen Realizada", valor: 8400 },
        { etapa: "Control", valor: 4800 },
      ],
      fuga_global: 52.4,
      tiempo_espera_min: 15,
      nps: 79,
      volumen_total: 28600,
    },
    "Pediatría": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 42800 },
        { etapa: "Agendamiento", valor: 31200 },
        { etapa: "Consulta", valor: 29400 },
        { etapa: "Indicación", valor: 12800 },
        { etapa: "Lab Realizado", valor: 8900 },
        { etapa: "Imagen Realizada", valor: 3200 },
        { etapa: "Control", valor: 9800 },
      ],
      fuga_global: 42.8,
      tiempo_espera_min: 14,
      nps: 82,
      volumen_total: 42800,
    },
    "Endocrinología": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 19800 },
        { etapa: "Agendamiento", valor: 12600 },
        { etapa: "Consulta", valor: 11400 },
        { etapa: "Indicación", valor: 8900 },
        { etapa: "Lab Realizado", valor: 7200 },
        { etapa: "Imagen Realizada", valor: 1800 },
        { etapa: "Control", valor: 3400 },
      ],
      fuga_global: 55.8,
      tiempo_espera_min: 24,
      nps: 71,
      volumen_total: 19800,
    },
    "Traumatología": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 24600 },
        { etapa: "Agendamiento", valor: 16800 },
        { etapa: "Consulta", valor: 15200 },
        { etapa: "Indicación", valor: 9400 },
        { etapa: "Lab Realizado", valor: 2200 },
        { etapa: "Imagen Realizada", valor: 8600 },
        { etapa: "Control", valor: 4100 },
      ],
      fuga_global: 48.9,
      tiempo_espera_min: 21,
      nps: 74,
      volumen_total: 24600,
    },
    "Dermatología": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 18400 },
        { etapa: "Agendamiento", valor: 12100 },
        { etapa: "Consulta", valor: 11200 },
        { etapa: "Indicación", valor: 4800 },
        { etapa: "Lab Realizado", valor: 1200 },
        { etapa: "Imagen Realizada", valor: 800 },
        { etapa: "Control", valor: 3900 },
      ],
      fuga_global: 45.2,
      tiempo_espera_min: 19,
      nps: 77,
      volumen_total: 18400,
    },
    "Ginecología y Obstetricia": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 26800 },
        { etapa: "Agendamiento", valor: 18400 },
        { etapa: "Consulta", valor: 16800 },
        { etapa: "Indicación", valor: 9200 },
        { etapa: "Lab Realizado", valor: 6800 },
        { etapa: "Imagen Realizada", valor: 5100 },
        { etapa: "Control", valor: 5400 },
      ],
      fuga_global: 38.7,
      tiempo_espera_min: 17,
      nps: 80,
      volumen_total: 26800,
    },
    "Neurología": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 12400 },
        { etapa: "Agendamiento", valor: 8200 },
        { etapa: "Consulta", valor: 7400 },
        { etapa: "Indicación", valor: 5100 },
        { etapa: "Lab Realizado", valor: 2800 },
        { etapa: "Imagen Realizada", valor: 4200 },
        { etapa: "Control", valor: 2400 },
      ],
      fuga_global: 41.1,
      tiempo_espera_min: 32,
      nps: 69,
      volumen_total: 12400,
    },
    "Psiquiatría": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 9800 },
        { etapa: "Agendamiento", valor: 6400 },
        { etapa: "Consulta", valor: 5800 },
        { etapa: "Indicación", valor: 3100 },
        { etapa: "Lab Realizado", valor: 900 },
        { etapa: "Imagen Realizada", valor: 300 },
        { etapa: "Control", valor: 2400 },
      ],
      fuga_global: 36.4,
      tiempo_espera_min: 35,
      nps: 73,
      volumen_total: 9800,
    },
    "Otorrinolaringología": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 22400 },
        { etapa: "Agendamiento", valor: 15100 },
        { etapa: "Consulta", valor: 13800 },
        { etapa: "Indicación", valor: 7200 },
        { etapa: "Lab Realizado", valor: 1800 },
        { etapa: "Imagen Realizada", valor: 5400 },
        { etapa: "Control", valor: 4200 },
      ],
      fuga_global: 46.8,
      tiempo_espera_min: 18,
      nps: 76,
      volumen_total: 22400,
    },
    "Medicina General": {
      funnel: [
        { etapa: "Búsqueda Web", valor: 15600 },
        { etapa: "Agendamiento", valor: 10200 },
        { etapa: "Consulta", valor: 9400 },
        { etapa: "Indicación", valor: 5800 },
        { etapa: "Lab Realizado", valor: 4200 },
        { etapa: "Imagen Realizada", valor: 1100 },
        { etapa: "Control", valor: 3100 },
      ],
      fuga_global: 52.1,
      tiempo_espera_min: 20,
      nps: 70,
      volumen_total: 15600,
    },
  },
};
